import classNames from "classnames"
import styles from "../../../../styles/LandingPage/Patients.module.scss"
import { FC } from "react"
import { SectionProps } from "./SectionType"

const SectionTwo: FC<SectionProps> = ({ children, backgroundColor }) => {
  return (
    <section
      style={{backgroundColor: backgroundColor, minHeight: "450px" }}
      className={classNames(styles.sectionMedium, styles.sectionTwo)}
    >
      {children}
    </section>
  )
}

export default SectionTwo